import { render, staticRenderFns } from "./subTitle.vue?vue&type=template&id=31910a55&scoped=true"
import script from "./subTitle.vue?vue&type=script&lang=js"
export * from "./subTitle.vue?vue&type=script&lang=js"
import style0 from "./subTitle.vue?vue&type=style&index=0&id=31910a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31910a55",
  null
  
)

export default component.exports